import React from "react";

function PanelHeader(props) {
  return (
    <div
      style={{
        padding: '0px',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        paddingTop: '50px',
      }}
      className={
        "panel-header " +
        (props.size !== undefined ? "panel-header-" + props.size : "")
      }
    >
      <img
        alt=""
        style={{
          maxHeight: '200%',
          maxWidth: '200%',
          objectFit: 'contain'
        }}
        src={props.content}
      />
    </div>
  );
}
 
export default PanelHeader;